module.exports = __webpack_public_path__ + "static/media/profesionalism2.996095d5.svg";